import React, { Component } from 'react'
import _, { isNumber } from 'lodash'
import { inject, observer } from 'mobx-react'
import { extendObservable, runInAction, intercept } from 'mobx'
import styled, { keyframes } from 'styled-components'
import { TweenMax, TimelineMax } from 'gsap'
import UnresolvedIcon from '@/assets/images/preplay-unresolved.svg'
import DDStar from '@/Components/CommandHost/Common/DDStar'
import TeamItem from '@/Components/CommandHost/Common/TeamItem'
import PendingIndicatorIcon from '@/assets/images/pending-indicator.svg'
import { OptionInputsWrapper, StarWrapper } from './style'
import DDAnnounceSponsor from '@/Components/CommandHost/Common/DDAnnounceSponsor'
import { responsiveDimension } from '../../utils'

const PlayColors = {
  liveplay: '#c61818',
  gamemaster: '#19d1bf',
  sponsor: '#495bdb',
  prize: '#9368aa',
}

@inject(
  'PrePlayStore',
  'CommandHostStore',
  'AutomationStore',
  'GameStore',
  'CommonStore'
)
@observer
export default class PlayItemUnresolved extends Component {
  constructor(props) {
    super(props)
    FONT_SIZE = this.props.CommandHostStore.fontSize + 'vh'
    extendObservable(this, {
      error: null,
      pushed: false,
      isStarted: false,
      isEnded: false,
      result: {
        id: 0,
        type: '',
        correctAnswer: '',
        correctAnswers: [],
        resultTitle: '',
        selectedTeam: {},
        withStar: false,
      },
      isResolving: false,
      sessionStarted: this.props.GameStore.isSessionStarted,
    })

    this.MAIN_CHOICE = this.props.item.multiplierChoices.filter(
      o => o.id == this.props.item.id
    )[0]

    this.state = {
      isOpinionQuestion: false,
      isPlayStatusUpdateEnabled: false,
    }

    this.destroySessionMode = intercept(
      this.props.GameStore,
      'sessionMode',
      change => {
        this.sessionStarted = change.newValue === 1
        this.forceUpdate()
        return change
      }
    )
  }

  handleStartPlayClick() {
    this.isStarted = true
    this.props.startPlay()
  }

  handleEndPlayClick() {
    this.isEnded = true
    this.props.endPlayResult()
  }

  handleShowResultClick() {
    this.error = null
    let required = []
    if (!this.result.correctAnswer) {
      required.push('Correct answer')
    }
    if (!this.result.resultTitle) {
      required.push('Results field')
    }
    if (!this.result.selectedTeam) {
      required.push('Team')
    }
    if (
      this.result.selectedTeam &&
      !this.result.selectedTeam.id &&
      !this.result.selectedTeam.teamName
    ) {
      required.push('Team')
    }

    if (required.length > 0) {
      this.error = required
      const promptRequired = document.getElementById('prompt-required')
      if (promptRequired) {
        setTimeout(() => {
          new TimelineMax({ repeat: 0 })
            .to(promptRequired, 0.1, { visibility: 'visible', opacity: 1 })
            .to(promptRequired, 0.1, {
              visibility: 'hidden',
              opacity: 0,
              delay: 3,
            })
        }, 0)
      }
    } else {
      this.result.correctAnswers.forEach(correctAnswer => {
        const option = document.getElementById(correctAnswer.highlightedOption)
        TweenMax.set(option, { backgroundColor: '#18c5ff' })
      })

      let multiItem = this.props.item.multiplierItems[
        this.props.item.multiplierItems.length - 1
      ]
      if (multiItem) {
        let multiChoice = this.props.item.multiplierChoices.filter(
          o => o.id === multiItem.id
        )[0]
        if (multiChoice) {
          multiChoice.locked = true
        }
      }

      TweenMax.set(this.ResultTitleInput, {
        backgroundColor: '#18c5ff',
        color: '#ffffff',
        readOnly: true,
      })
      TweenMax.set(this[`playitemload-${this.props.item.index}`], {
        backgroundColor: '#18c5ff',
        color: '#ffffff',
      })
      this.pushed = true

      this.props.showResult(this.result)
      setTimeout(() => {
        this.props.resolve()
      }, 4000)
    }
  }

  handleSelectAnswer(
    multiplierChoice,
    index,
    reference,
    multiplierCountX,
    prevItemToLock,
    automationMultiplierFlag,
    isAutoResolvingOpinions
  ) {
    setTimeout(() => {
      if (multiplierCountX === 2) {
        this.props.item.multiplierItems = []
      }

      // const down = this.props.item.multiplierItems.length - multiplierCountX
      // for (let x=this.props.item.multiplierItems.length - 1; x>=down; x--) {
      //   this.props.item.multiplierItems.splice(x, 1)
      // }

      for (let i = 0; i < multiplierChoice.choices.length; i++) {
        const option = document.getElementById(`${reference}-${i}`)

        if (index === i) {
          const ans = multiplierChoice.choices[i]
          if (
            !isAutoResolvingOpinions &&
            (this.result.correctAnswer === ans.value ||
              this.result.resultTitle.includes(ans.value))
          ) {
            this.result.correctAnswer = ''
            let removedAnsIdx = null
            this.result.correctAnswers = this.result.correctAnswers.filter(
              (answer, idx) => {
                let isAnswerStays = true
                if (answer && answer.correctAnswer) {
                  isAnswerStays = answer.correctAnswer.value !== ans.value
                  if (!isAnswerStays) removedAnsIdx = idx
                }
                return (
                  isAnswerStays &&
                  (!isNumber(removedAnsIdx) || removedAnsIdx > idx)
                )
              }
            )
            try {
              let preResult = ''
              for (let x = 0; x < this.result.correctAnswers.length; x++) {
                const ca = this.result.correctAnswers[x]
                preResult += ca.correctAnswer.value + ', '
              }

              this.result.resultTitle = preResult.slice(0, -2)
            } catch (error) {
              console.error(' error while updating resultTitle : ', error)
            }
            if (option) {
              TweenMax.set(option, { backgroundColor: '#808285' })
            }
          } else {
            this.result.correctAnswer = ans.value

            this.pushCorrectAnswer(
              multiplierChoice.id,
              multiplierChoice.choices[i],
              multiplierCountX,
              `${reference}-${i}`
            )
            this.pushMultiplierItem(ans.nextId, ans.value, multiplierCountX)

            /**
             * Lock previous multiplier choice after selecting on the current choice
             */
            if (prevItemToLock) {
              prevItemToLock.locked = true
            }

            TweenMax.set(option, { backgroundColor: '#0fbc1c' })

            this.props.AutomationStore.addTempUnresolvedEvent({
              evt: 'click',
              refId: `${reference}-${i}`,
              wait: 0.5,
              playId: this.props.item.id,
              multiplierFlag: automationMultiplierFlag,
            })
          }
        } else {
          if (option) TweenMax.set(option, { backgroundColor: '#808285' })
        }
      }
    }, 0)
  }

  async handleConfirmClick(itemId, refId) {
    const _editorEvents = []
    if ('recording' === this.props.GameStore.executionType) {
      await _editorEvents.push({
        gameId: this.props.GameStore.gameId,
        playId: null,
        evt: 'delay',
        refId: refId,
        wait: 0,
        sequence: 0,
        isIncrementHeaderPlaySequence: false,
        isIncrementPlaySequence: false,
        isIncrementSequence: true,
        timestampWait: 0,
        isPreviousPlayEnded: true,
        isUseGlobalTimestampWait: true,
      })

      for (
        let i = 0;
        i < this.props.AutomationStore.tempUnresolvedEvents.length;
        i++
      ) {
        const event = this.props.AutomationStore.tempUnresolvedEvents[i]
        await _editorEvents.push(event)
      }

      await _editorEvents.push({
        gameId: this.props.GameStore.gameId,
        playId: this.props.item.id,
        evt: 'click',
        refId: refId,
        wait: 0,
        sequence: 0,
        isIncrementHeaderPlaySequence: false,
        isIncrementPlaySequence: false,
        isIncrementSequence: true,
        timestampWait: 0,
        isPreviousPlayEnded: false,
      })
      ////////////////////////////////////////////////////////this.props.AutomationStore.resetCurrentTime()
    }

    this.isResolving = true

    this.result.correctAnswers.forEach(correctAnswer => {
      const option = document.getElementById(correctAnswer.highlightedOption)
      TweenMax.set(option, { backgroundColor: '#18c5ff' })
    })

    this.result.selectedTeam = this.props.item.team
    this.result.status = 'pending'

    this.props.item.result = this.result
    TweenMax.set(this[`pending-indicator-${itemId}`], { display: 'flex' })
    setTimeout(() => {
      this.props.resolvePending({
        id: this.props.item.id,
        result: this.result,
        executionType: this.props.GameStore.executionType,
        editorEvents:
          'recording' === this.props.GameStore.executionType
            ? _editorEvents
            : null,
      })
      this.props.AutomationStore.resetTempUnresolvedEvents()
    }, 0)
  }

  removeAnswer = (key, value) => {
    if (this.result) {
      if (key === 'id') {
        this.result.correctAnswers = this.result.correctAnswers.filter(
          answer => answer && answer.correctAnswer.id !== value
        )
        return
      }
      const toRemove = this.result.correctAnswers.filter(
        o => o[key] === value
      )[0]
      if (toRemove) {
        const idxToRemove = this.result.correctAnswers.indexOf(toRemove)
        if (idxToRemove > -1) {
          this.result.correctAnswers.splice(idxToRemove, 1)
        }
      }
    }
  }

  pushCorrectAnswer(id, correctAnswer, multiplierCountX, option) {
    /**
     * Remove existing answer
     */
    const answerMultipliers = [...this.result.correctAnswers]
    for (let i = answerMultipliers.length - 1; i >= 0; i--) {
      if (
        this.props.item &&
        this.props.item.pmetadata &&
        this.props.item.pmetadata.public &&
        this.props.item.pmetadata.public.opinionQuestion
      ) {
        if (
          correctAnswer &&
          answerMultipliers[i] &&
          answerMultipliers[i].correctAnswer &&
          answerMultipliers[i].correctAnswer.id === correctAnswer.id &&
          answerMultipliers[i].correctAnswer.value === correctAnswer.value
        ) {
          this.removeAnswer('id', correctAnswer.id)
        }
      } else {
        const mulX = answerMultipliers[i].multiplier
        if (mulX >= multiplierCountX) {
          this.removeAnswer('multiplier', mulX)
        }
      }
    }

    // const toRemove = this.result.correctAnswers.filter(
    //   o => o.multiplier === multiplierCountX
    // )[0]
    // if (toRemove) {
    //   const idxToRemove = this.result.correctAnswers.indexOf(toRemove)
    //   if (idxToRemove > -1) {
    //     this.result.correctAnswers.splice(idxToRemove, 1)
    //   }
    // }

    /**
     * Push new answer
     */
    let ans = {
      id: id,
      multiplier: multiplierCountX,
      correctAnswer: correctAnswer,
      highlightedOption: option,
    }
    this.result.correctAnswers.push(ans)

    let preResult = ''
    for (let x = 0; x < this.result.correctAnswers.length; x++) {
      const ca = this.result.correctAnswers[x]
      preResult += ca.correctAnswer.value + ', '
    }

    this.result.resultTitle = preResult.slice(0, -2)
  }

  pushMultiplierItem(nextId, answer, multiplierCountX) {
    /**
     * Remove existing item
     */
    /*
    const mulItems = [...this.props.item.multiplierItems]
    for (let i=mulItems.length - 1; i>=0; i--) {
      debugger
      const mulX = mulItems[i].multiplier
      if (mulX >= multiplierCountX) {
        const toRemove = this.props.item.multiplierItems.filter(o => o.multiplier === mulX)[0]
        if (toRemove) {
          const idxToRemove = this.props.item.multiplierItems.indexOf(toRemove)
          if (idxToRemove > -1) {
            this.props.item.multiplierItems.splice(idxToRemove, 1)
          }
        }
      }
    }
*/

    const multiItemToRemove = this.props.item.multiplierItems.filter(
      o => o.multiplier === multiplierCountX
    )[0]
    if (multiItemToRemove) {
      const multiItemIndex = this.props.item.multiplierItems.indexOf(
        multiItemToRemove
      )
      if (multiItemIndex > -1) {
        this.props.item.multiplierItems.splice(multiItemIndex, 1)
      }
    }

    /**
     * Push new item
     */
    let multiItem = this.props.item.multiplierChoices.filter(
      o => o.id === nextId
    )[0]
    if (multiItem) {
      multiItem.multiplier = multiplierCountX
      multiItem.previousAnswer = answer
      this.props.item.multiplierItems.push(multiItem)
    }

    this.forceUpdate()
  }

  ResultOptions() {
    let comp = []
    let { item } = this.props

    if (!item) return null
    const resultOptionLoadId = `unresolvedplay-result-option-${this.props.item.type}-1-${this.props.item.id}`
    const automationMultiplierFlag = `unresolvedplay-result-option-${this.props.item.type}-1`
    if (this.MAIN_CHOICE && this.MAIN_CHOICE.choices) {
      if (this.MAIN_CHOICE.readOnly && !this.MAIN_CHOICE.choices.length) {
        this.MAIN_CHOICE.choices.push({ value: '{player1}' })
        this.MAIN_CHOICE.choices.push({ value: '{player2}' })
      }
      const choices = this.MAIN_CHOICE.choices.sort(
        (a, b) => a.sequence - b.sequence
      )
      for (let i = 0; i < choices.length; i++) {
        const mulChoice = choices[i]
        let propsItemChoice = this.props.item.choices.filter(o => {
          const _ov = (o.value || '').toLowerCase()
          if (_ov === (mulChoice.value || '').toLowerCase()) return true
          if (!mulChoice) return false
          const _mulChoice = this.preprocessPresetChoice(
            mulChoice.value,
            null,
            null,
            null,
            null,
            true
          )
          return _ov === (_mulChoice ? _mulChoice.toLowerCase() : '')
        })[0]
        if (
          propsItemChoice &&
          propsItemChoice.value &&
          choices[i].value &&
          propsItemChoice.value.toLowerCase() !==
            choices[i].value.toLowerCase() &&
          this.preprocessPresetChoice(choices[i].value, null, null, true)
        )
          propsItemChoice = choices[i]
        if (propsItemChoice) {
          let _comp_from_tpl = propsItemChoice.value
            ? this.preprocessPresetChoice(
                propsItemChoice.value,
                resultOptionLoadId,
                i,
                item,
                automationMultiplierFlag
              )
            : null
          if (_comp_from_tpl) {
            comp.push(_comp_from_tpl)
          } else {
            comp.push(
              <ResultOption
                locked={!this.sessionStarted}
                id={`${resultOptionLoadId}-${i}`}
                key={i}
                color={'#ffffff'}
                marginRight={
                  this.MAIN_CHOICE &&
                  i < (this.MAIN_CHOICE.choices || []).length - 1
                }
                onClick={
                  !this.sessionStarted
                    ? null
                    : this.handleSelectAnswer.bind(
                        this,
                        this.MAIN_CHOICE,
                        i,
                        resultOptionLoadId,
                        2,
                        null,
                        automationMultiplierFlag
                      )
                }
                isCorrectAnswer={this.correctAnswer - 1 === i}
              >
                {propsItemChoice.value}
              </ResultOption>
            )
          }
        }
      }
    }

    return comp
  }

  preprocessPresetChoice(
    choice,
    reference,
    i,
    item,
    automationMultiplierFlag,
    return_match
  ) {
    const field = choice.match(/^\{(\w+)\}$/)
    if (field) {
      const field_match = field[1].match(/^player(\d+)$/i)
      if (field_match) {
        if (return_match)
          return this.props.PrePlayStore.teams.length >= field_match[1]
            ? this.props.PrePlayStore.teams[field_match[1] - 1].teamName
            : null
        return this.preprocessPresetChoicePlayer(
          field_match[1],
          reference,
          i,
          item,
          automationMultiplierFlag
        )
      }
    }
    for (let _i = 0; _i < this.props.PrePlayStore.teams.length; ++_i) {
      if (this.props.PrePlayStore.teams[_i].teamName === choice)
        return return_match
          ? choice
          : this.preprocessPresetChoicePlayer(
              _i + 1,
              reference,
              i,
              item,
              automationMultiplierFlag
            )
    }
    return null
  }

  preprocessPresetChoicePlayer(
    player_number,
    reference,
    i,
    item,
    automationMultiplierFlag
  ) {
    const t = this.props.PrePlayStore.teams[player_number - 1]
    runInAction(() => {
      if (this.props.item.choices[i]) {
        this.props.item.choices[i].id = t.id
        this.props.item.choices[i].value = t.teamName
      }
      if (item.multiplierChoices[0].choices[i]) {
        item.multiplierChoices[0].choices[i].id = t.id
        item.multiplierChoices[0].value = t.teamName
      }
    })

    return (
      <TeamItemWrapper
        locked={!this.sessionStarted}
        id={`${reference}-${i}`}
        key={`result-option-load${i}`}
        marginRight={
          this.MAIN_CHOICE && i < (this.MAIN_CHOICE.choices || []).length - 1
        }
        onClick={
          !this.sessionStarted
            ? null
            : this.handleSelectAnswer.bind(
                this,
                item.multiplierChoices[0],
                i,
                reference,
                2,
                null,
                automationMultiplierFlag
              )
        }
      >
        <TeamItem team={t} isCorrectAnswer={this.correctAnswer - 1 === i} />
      </TeamItemWrapper>
    )
  }

  MultiplierResultOptions() {
    let comp = []
    let { item } = this.props

    for (let i = 0; i < item.multiplierItems.length; i++) {
      const multiplierChoice = item.multiplierItems[i]
      const choices = item.multiplierItems[i].choices
      const previousAnswer = item.multiplierItems[i].previousAnswer
      const multiplier = item.multiplierItems[i].multiplier

      const prevItemToLock = item.multiplierChoices[i]
      const currItemToLock = item.multiplierChoices[i + 1]
      const reference = 'result-option-multiplier-unresolved-' + item.index

      comp.push(
        <MultiplierResultOptionWrapperOuterRow key={i}>
          <PreviousAnswer>{previousAnswer}</PreviousAnswer>
          <MultiplierLabel>{multiplier}x</MultiplierLabel>
          <MultiplierResultOptionWrapperInner>
            {(choices || []).map((choice, idx) => {
              const resultOptionLoadMultiplierId = `unresolvedplay-result-option-${this.props.item.type}-${multiplier}-${this.props.item.id}`
              const automationMultiplierFlag = `unresolvedplay-result-option-${this.props.item.type}-${multiplier}`
              return (
                <ResultOption
                  //locked={currItemToLock.locked}
                  locked={!this.sessionStarted}
                  id={`${resultOptionLoadMultiplierId}-${idx}`}
                  key={idx}
                  color={'#ffffff'}
                  marginRight={idx < (choices || []).length - 1}
                  onClick={
                    !this.sessionStarted
                      ? null
                      : this.handleSelectAnswer.bind(
                          this,
                          multiplierChoice,
                          idx,
                          resultOptionLoadMultiplierId,
                          i + 3,
                          prevItemToLock,
                          automationMultiplierFlag
                        )
                  }
                >
                  {choice.value}
                </ResultOption>
              )
            })}
          </MultiplierResultOptionWrapperInner>
        </MultiplierResultOptionWrapperOuterRow>
      )
    }

    // if (item.multiplierItems.length > 0) {
    //   comp.push(<MultiplierResultOptionRemoveButton key={10} onClick={ () => {
    //     console.log('RESULT - CORRECT ANSWERS', this.result.correctAnswers)
    //   } } />)
    // }

    return comp
  }

  copyChoicesIntoMultiplierChoices() {
    const multiChoice = this.props.item.multiplierChoices[0]
    if (multiChoice) {
      if (!multiChoice.question || multiChoice.question.trim().length < 1) {
        multiChoice.question = this.props.item.playTitle.value
      }
      multiChoice.choices = this.props.item.choices
    }
  }

  resolveOpinions() {
    let { item } = this.props

    if (!item) return null
    const resultOptionLoadId = `unresolvedplay-result-option-${item.type}-1-${item.id}`
    const automationMultiplierFlag = `unresolvedplay-result-option-${item.type}-1`
    if (this.MAIN_CHOICE && this.MAIN_CHOICE.choices) {
      if (this.MAIN_CHOICE.readOnly && !this.MAIN_CHOICE.choices.length) {
        this.MAIN_CHOICE.choices.push({ value: '{player1}' })
        this.MAIN_CHOICE.choices.push({ value: '{player2}' })
      }
      const choices = this.MAIN_CHOICE.choices.sort(
        (a, b) => a.sequence - b.sequence
      )
      for (let i = 0; i < choices.length; i++) {
        const mulChoice = choices[i]
        let propsItemChoice = this.props.item.choices.filter(o => {
          const _ov = (o.value || '').toLowerCase()
          if (_ov === (mulChoice.value || '').toLowerCase()) return true
          if (!mulChoice) return false
          const _mulChoice = this.preprocessPresetChoice(
            mulChoice.value,
            null,
            null,
            null,
            null,
            true
          )
          return _ov === (_mulChoice ? _mulChoice.toLowerCase() : '')
        })[0]
        if (
          propsItemChoice &&
          propsItemChoice.value &&
          choices[i].value &&
          propsItemChoice.value.toLowerCase() !==
            choices[i].value.toLowerCase() &&
          this.preprocessPresetChoice(choices[i].value, null, null, true)
        )
          propsItemChoice = choices[i]
        if (propsItemChoice) {
          this.handleSelectAnswer(
            this.MAIN_CHOICE,
            i,
            resultOptionLoadId,
            2,
            null,
            automationMultiplierFlag,
            true
          )
        }
      }
    }
  }

  componentWillUnmount() {
    this.destroySessionMode()
  }

  componentWillMount() {
    //--this.copyChoicesIntoMultiplierChoices()

    this.props.item.multiplierItems = []
    this.props.item.showNextPlayAd = this.props.item.length > 0 ? true : false
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.item !== this.props.item) {
      if (nextProps.item.multiplierChoices) {
        this.MAIN_CHOICE = nextProps.item.multiplierChoices.filter(
          o => o.id == nextProps.item.id
        )[0]
      }
      this.result.id = nextProps.item.id
      this.result.type = nextProps.item.type
      this.result.withStar = nextProps.item.stars
      this.result.selectedTeam = nextProps.item.team

      if (
        nextProps.item &&
        nextProps.item.pmetadata &&
        nextProps.item.pmetadata.public
      ) {
        const publicData = nextProps.item.pmetadata.public
        this.setState({
          isOpinionQuestion: publicData.opinionQuestion,
        })
      }
    }
  }

  async componentDidMount() {
    const { item } = this.props
    if (item) {
      this.correctAnswer =
        item.pmetadata &&
        item.pmetadata.public &&
        Number(item.pmetadata.public.correctanswer)
          ? Number(item.pmetadata.public.correctanswer)
          : null
      if (this.MAIN_CHOICE && this.MAIN_CHOICE.choices) {
        this.MAIN_CHOICE.choices.forEach((choice, idx) => {
          if (choice) choice.id = choice.id || idx
        })
      }
      this.result.id = item.id
      this.result.type = item.type
      this.result.withStar = item.stars
      const questionInputCont = document.getElementById(
        `play_item_unresolved_question_input_locked_${item.sequence}`
      )
      if (questionInputCont) {
        this.scrollHeight = questionInputCont.scrollHeight || 0
        this.clientHeight = questionInputCont.clientHeight || 0
      }
      delete this.props.item.editorEvents
      if (
        item.pmetadata &&
        item.pmetadata.public &&
        item.pmetadata.public.opinionQuestion
      ) {
        await this.resolveOpinions()
        const refId = `unresolved-button-${item.type}-${item.id}`
        this.handleConfirmClick(item.id, refId)
      }
      if (item.pmetadata && item.pmetadata.public) {
        const publicData = item.pmetadata.public
        this.setState({
          isOpinionQuestion: publicData.opinionQuestion,
        })
      }
      this.forceUpdate()
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.isOpinionQuestion !== nextState.isOpinionQuestion)
      return true
    if (
      this.state.isPlayStatusUpdateEnabled !==
      nextState.isPlayStatusUpdateEnabled
    )
      return true
    return false
  }

  getdisplayAwards(item) {
    var statData = this.props.CommonStore.displayAwards(
      item,
      'PlayItemUnresolved'
    )
    const playStats = this.props.GameStore.playStats
    var toBedisplayedStats = _.find(playStats, { gameplay_id: item.gamePlayId })
    if (toBedisplayedStats) {
      statData.TokensPlaced = toBedisplayedStats.spent
        ? toBedisplayedStats.spent
        : 0
      statData.BottomPoints =
        toBedisplayedStats.earned && toBedisplayedStats.earned.p
          ? toBedisplayedStats.earned.p
          : 0
      statData.BottomStars =
        toBedisplayedStats.earned && toBedisplayedStats.earned.s
          ? toBedisplayedStats.earned.s
          : 0
      statData.BottomTokens =
        toBedisplayedStats.earned && toBedisplayedStats.earned.t
          ? toBedisplayedStats.earned.t
          : 0
    }
    const textColor =
      (item.type || '').toLowerCase() === 'gamemaster' ? '#f1ecec' : '#d1cbcb'

    return (
      <div
        style={{
          fontSize: 'small',
          display: 'flex',
          justifyContent: 'center',
          height: '100%',
          flexDirection: 'column',
        }}
      >
        <AwardsWrapper style={{ justifyContent: 'space-between' }}>
          <div>
            <AwardHeader color={textColor}>PTS:</AwardHeader>
            <AwardValue>{statData.points || 0}</AwardValue>
            <VerticalDivider>|</VerticalDivider>
            <AwardHeader color={textColor}>TKNS:</AwardHeader>
            <AwardValue>{statData.tokens || 0}</AwardValue>
          </div>
          <div>
            <AwardHeader color={textColor}>TKNS PLACED:</AwardHeader>
            <AwardValue>{statData.TokensPlaced || 0}</AwardValue>
          </div>
        </AwardsWrapper>
        <div>
          <AwardsWrapper>
            <div>
              <AwardHeader color={textColor}>PTS:</AwardHeader>
              <AwardValue>{statData.BottomPoints || 0}</AwardValue>
            </div>
            <VerticalDivider>|</VerticalDivider>
            <div>
              <AwardHeader color={textColor}>STARS:</AwardHeader>
              <AwardValue>{statData.BottomStars || 0}</AwardValue>
            </div>
            <VerticalDivider>|</VerticalDivider>
            <div>
              <AwardHeader color={textColor}>TKNS:</AwardHeader>
              <AwardValue>{statData.BottomTokens || 0}</AwardValue>
            </div>
          </AwardsWrapper>
        </div>
      </div>
    )
  }

  getPlayAnalytics(item) {
    const playStats = this.props.GameStore.playStats
    var filteredPlaystats = _.filter(playStats, {
      gameplay_id: item.gamePlayId,
    })
    var playStatsNoReference = [...filteredPlaystats]
    var toBeDisplayedStats =
      playStatsNoReference.length > 1
        ? _.find(playStatsNoReference, function(tmp) {
            return tmp.stage === 'resolve'
          })
        : playStatsNoReference[0]
    let connected = 0
    if (playStatsNoReference.length > 1) {
      let previousStageStats = { ...playStatsNoReference[0] }
      connected =
        previousStageStats.played + previousStageStats.played_tmp >
        previousStageStats.connected
          ? previousStageStats.played + previousStageStats.played_tmp
          : previousStageStats.connected
    } else {
      if (toBeDisplayedStats)
        connected =
          toBeDisplayedStats.played + toBeDisplayedStats.played_tmp >
          toBeDisplayedStats.connected
            ? toBeDisplayedStats.played + toBeDisplayedStats.played_tmp
            : toBeDisplayedStats.connected
    }
    var analyticsData = { TotalPlayers: 0, Missed: 0, Correct: 0, Incorrect: 0 }
    analyticsData.TotalPlayers = connected
    analyticsData.Missed = toBeDisplayedStats
      ? connected - toBeDisplayedStats.played - toBeDisplayedStats.played_tmp
      : 0
    analyticsData.Correct = 0
    analyticsData.Incorrect = 0

    return (
      <PlayAnalyticsWrapper>
        <AwardsWrapper style={{ justifyContent: 'space-between' }}>
          <div style={{ width: '50%', maxWidth: '50%' }}>
            <AwardHeader color="#524f4f">PLAYERS:</AwardHeader>
            <AwardValue style={{ color: '#3CB878' }}>
              {analyticsData.TotalPlayers || 0}
            </AwardValue>
          </div>
          <div style={{ width: '50%', maxWidth: '50%' }}>
            <AwardHeader color="#524f4f">CORRECT:</AwardHeader>
            <AwardValue style={{ color: '#000', paddingLeft: '9px' }}>
              {analyticsData.Correct || 0}
            </AwardValue>
            <AwardValuePercentage style={{ color: '#6778e2' }}>
              {analyticsData.Correct === 0
                ? `0%`
                : `${_.round(
                    (analyticsData.Correct / analyticsData.TotalPlayers) * 100
                  )}%`}
            </AwardValuePercentage>
          </div>
        </AwardsWrapper>
        <div>
          <AwardsWrapper>
            <div style={{ width: '50%', maxWidth: '50%' }}>
              <AwardHeader color="#524f4f">MISSED:</AwardHeader>
              <AwardValue style={{ color: '#000' }}>
                {analyticsData.Missed || 0}
              </AwardValue>
              <AwardValuePercentage style={{ color: '#6778e2' }}>
                {analyticsData.Missed === 0
                  ? `0%`
                  : `${this.getAwardValuePercentage({
                      missed: true,
                      toBeDisplayedStats: toBeDisplayedStats,
                      item: item,
                      analyticsData: analyticsData,
                    }) || 0}%`}
              </AwardValuePercentage>
            </div>
            <div style={{ width: '50%', maxWidth: '50%' }}>
              <AwardHeader color="#524f4f">INCORRECT:</AwardHeader>
              <AwardValue style={{ color: '#000' }}>
                {analyticsData.Incorrect || 0}
              </AwardValue>
              <AwardValuePercentage style={{ color: '#6778e2' }}>
                {analyticsData.Incorrect === 0
                  ? `0%`
                  : `${_.round(
                      (analyticsData.Incorrect / analyticsData.TotalPlayers) *
                        100
                    )}%`}
              </AwardValuePercentage>
            </div>
          </AwardsWrapper>
        </div>
      </PlayAnalyticsWrapper>
    )
  }

  getAwardValuePercentage(data) {
    if (data && data.toBeDisplayedStats) {
      if (data.missed) {
        return _.round(
          (data.analyticsData.Missed / data.analyticsData.TotalPlayers) * 100
        )
      }
    }
  }

  getType(type) {
    type = type.toLowerCase()
    return type === 'liveplay'
      ? 'live'
      : type === 'gamemaster'
      ? 'game'
      : type === 'sponsor'
      ? 'spon'
      : type === 'prize'
      ? 'priz'
      : type
  }

  async handlePlayStatusClick() {
    if (!this.state.isPlayStatusUpdateEnabled) {
      this.setState({ isPlayStatusUpdateEnabled: true })
      this.playUpdateTimeout = setTimeout(() => {
        this.setState({ isPlayStatusUpdateEnabled: false })
      }, 5000)
    } else {
      if (this.playUpdateTimeout) {
        clearTimeout(this.playUpdateTimeout)
      }
      this.setState({ isOpinionQuestion: true })
      this.handleAwardValue({
        name: 'opinionQuestion',
        value: true,
      })
      this.componentDidMount()
      this.setState({ isPlayStatusUpdateEnabled: false })
    }
  }

  handleAwardValue(specialFeature = null) {
    if (specialFeature && this.props.item) {
      let pmetadata = this.props.item.pmetadata || {}
      pmetadata.public = pmetadata.public || {}
      pmetadata.public[specialFeature.name] = specialFeature.value
      pmetadata.public.isCancelledPlay = true
      this.props.item.pmetadata = pmetadata
    }
    this.handleUpdateChanges(true)
  }

  handleUpdateChanges(force) {
    if (
      force ||
      (this.props.item &&
        this.props.item.multiplierChoices &&
        this.props.item.multiplierChoices.length > 0)
    ) {
      this.props.gamesUpdate(this.props.item)
      this.forceUpdate()
    }
  }

  render() {
    let { item } = this.props
    if (!item) return null
    let bg = PlayColors[this.props.item.type.toLowerCase()]

    //let isLocked = this.result.correctAnswer ? false : true
    let isLocked = !this.sessionStarted
      ? true
      : this.props.item.multiplierItems.length + 1 !==
        this.result.correctAnswers.length
      ? true
      : false

    const unresolvedButtonId = `unresolved-button-${item.type}-${item.id}`
    const editorReadOnly3Announce = `editor-readonly-3-Announce-${this.props.AutomationStore.playSequence}`
    const { isOpinionQuestion } = this.state

    return (
      <Container>
        <StackWrapper>
          <Main>
            <PlayStatusWrapper
              isPlayStatusUpdateEnabled={this.state.isPlayStatusUpdateEnabled}
              onClick={this.handlePlayStatusClick.bind(this)}
            />
            <PlayTypeDD>
              <PrePlaySequence backgroundColor={bg} text={`${item.sequence}`} />
              <PrePlayLocked backgroundColor={bg}>
                <span>{`${this.getType(item.type)}`}</span>
                {isOpinionQuestion && (
                  <TextButton
                    name="opn"
                    color={'#000'}
                    backgroundColor={'#EFDF18'}
                    width={1.7}
                    height={1.2}
                  >
                    {'OPN'}
                  </TextButton>
                )}
              </PrePlayLocked>
            </PlayTypeDD>
            <SelectTypeLocked title={this.MAIN_CHOICE.preset}>
              {this.MAIN_CHOICE.preset}
            </SelectTypeLocked>
            <QuestionInputLocked
              id={`play_item_unresolved_question_input_locked_${item.sequence}`}
              style={{
                alignItems:
                  this.scrollHeight - this.clientHeight > 5
                    ? 'flex-start'
                    : 'center',
              }}
            >
              {this.MAIN_CHOICE.question}
            </QuestionInputLocked>
            <OptionInputsWrapper>{this.ResultOptions()}</OptionInputsWrapper>
            <StarWrapper style={{ height: `${h}vh` }}>
              <DDStar
                from="PlayItemUnresolved"
                locked
                item={item}
                height={h}
                index={'playitemunresolved-' + item.index}
                value={val => {
                  this.props.item.stars = val
                }}
              />
            </StarWrapper>
            {/* <SponsorBrandWrapper>
              <DDSponsorBrand
                height={h}
                index={'playitemunresolved-' + item.index}
                selectedSponsor={item.sponsor}
                value={val => {
                  item.sponsor = val
                }}
                locked
              />
            </SponsorBrandWrapper> */}
            <AwardsDisplay backgroundColor={bg}>
              {this.getdisplayAwards(item)}
            </AwardsDisplay>
            {this.getPlayAnalytics(item)}
            <ButtonGroup>
              <DDSponsorWrapper
                className={`${this.reference}-sponsor`}
                style={{
                  display: 'block',
                  marginLeft: '0.2vh',
                }}
              >
                <DDAnnounceSponsor
                  locked
                  height={h}
                  index={`${this.reference}-sponsor`}
                  selectedSponsor={null}
                  expanded={item.sponsorExpanded}
                  forId={editorReadOnly3Announce}
                  PlayStoreSample={this.props.PrePlayStore}
                  subType={item ? item.subType : null}
                  sponsorId={item.sponsorId}
                  playStackFromUnresolved={true}
                  fromStack="PLAY_ITEM"
                  sponsorMetaData={
                    item.sponsor ? item.sponsor.sponsorItem || null : null
                  }
                  pmetadata={
                    item.pmetadata ? item.pmetadata.public || null : null
                  }
                />
              </DDSponsorWrapper>
              <ConfirmButton
                id={unresolvedButtonId}
                locked={isLocked}
                resolving={this.isResolving}
                onClick={
                  isLocked || this.isResolving
                    ? null
                    : this.handleConfirmClick.bind(
                        this,
                        this.props.item.id,
                        unresolvedButtonId
                      )
                }
              >
                <PendingIndicator
                  src={PendingIndicatorIcon}
                  innerRef={ref =>
                    (this[`pending-indicator-${this.props.item.id}`] = ref)
                  }
                />
              </ConfirmButton>
            </ButtonGroup>
          </Main>

          <MultiplierWrapper>
            {this.MultiplierResultOptions()}
          </MultiplierWrapper>
        </StackWrapper>
      </Container>
    )
  }
}

const h = 6
let FONT_SIZE = '1.8vh'

const AwardsDisplay = styled.div`
  background-color: ${props => props.backgroundColor};
  color: white;
  height: 100%;
  padding-left: 2px;
  padding-right: 2px;
  font-family: pamainregular;
  max-width: 16%;
  min-width: 16%;
`

const Container = styled.div`
  width: 100%;
  opacity: 0;
  animation: ${props => fadeIn} 0.3s forwards;
  height: auto;
  margin-bottom: ${props => 0.2}vh;
`
const fadeIn = keyframes`
  0%{opacity: 0;}
  100%{opacity: 1}
`

const Main = styled.div`
  width: inherit;
  height: ${props => h}vh;
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Sub = styled.div`
  width: 90%;
  background: yellow;
`

const PrePlaySequence = styled.div`
  width: 40%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainlight;
  font-size: ${props => FONT_SIZE};
  color: white;
  line-height: 1;
  border-right: 0.5px solid;
  &:after {
    content: '${props => props.text}';
  }
`

const PrePlayLocked = styled.div`
  width: 60%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: white;
  text-transform: uppercase;
`

const TextButton = styled.div`
  position: absolute;
  left: 10%;
  top: 38%;
  padding-top: 0.1%;
  width: ${props => responsiveDimension(props.width || 2)};
  height: ${props => responsiveDimension(props.height || 2)};
  color: ${props => props.color || '#fff'};
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainregular;
  font-size: ${props => responsiveDimension(0.7)};
  border: ${responsiveDimension(0.2)} solid #000;
  opacity: ${props => (props.isDisabled ? 0 : '')};
  pointer-events: ${props => (props.isDisabled ? 'none' : '')};
`

const PlayTypeDD = styled.div`
  width: 10%;
  height: ${props => h}vh;
  display: flex;
`
const PlayStatusWrapper = styled.div`
  width: 3.5%;
  height: ${props => h}vh;
  background-color: ${props =>
    props.isPlayStatusUpdateEnabled ? '#efdf17' : '#a7a9ac'};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-image: url(${UnresolvedIcon});
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
`

const QuestionInputLocked = styled.div`
  width: 20%;
  height: inherit;
  font-family: pamainbold;
  font-size: ${props => 1.4}vh;
  text-transform: uppercase;
  // text-indent: ${props => 1}vh;
  background-color: #ffffff;
  display: flex;
  align-items: flex-start;
  padding-left: 1vh;
  overflow: auto;
  ms-overflow-style: ${'-ms-autohiding-scrollbar'};
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0.3vh rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
    border-radius: ${props => 1}vh;
  }
  &::-webkit-scrollbar {
    width: ${props => responsiveDimension(0.4)};
    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 0, 0, 0.6);
    &:hover {
      background-color: rgba(255, 0, 0, 1);
    }
    border-radius: ${props => 1}vh;
  }
  line-height: 1.6;
`

const SelectTypeLocked = styled.div`
  width: 7%;
  height: ${props => h}vh;
  background-color: #e5e5e5;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: #000000;
  text-transform: uppercase;
  display: block;
  text-align: center;
  line-height: ${props => h}vh;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0.5vh;
`

const SponsorBrandWrapper = styled.div`
  width: 12%;
  height: ${props => h}vh;
  display: flex;
`

const TeamItemWrapper = styled.div`
  width: 100%;
  height: inherit;
  background-color: #808285;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  ${props => (props.marginRight ? `margin-right:${2}px` : ``)};
`

const StackWrapper = styled.div`
  width: inherit;
  height: inherit;
  display: flex;
  flex-direction: column;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  user-select: text;
`

const MultiplierWrapper = styled.div`
  width: 100%;
  height: inherit;
  display: flex;
  flex-direction: column;
`

const ResultOption = styled.div`
  width: 100%;
  height: ${props => h}vh;
  background-color: #808285;
  animation: ${props =>
    props.isCorrectAnswer ? `${blinkBorder} 1s infinite` : ''};
  text-align: center;
  text-transform: uppercase;
  color: ${props => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${props => 1.4}vh;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  ${props => (props.marginRight ? `margin-right:${2}px` : ``)};
`

const blinkBorder = keyframes`
  0% {
    border: 4px solid #0fbc1c;
  }
  50% {
    border: 4px solid transparent;
  }
  100% {
    border: 4px solid #0fbc1c;
  }
`

const MultiplierResultOptionWrapperOuterRow = styled.div`
  height: inherit;
  display: flex
  flex-direction: row;
  margin-top: ${props => 0.2}vh;
  margin-left: 24.6%;
`

const MultiplierResultOptionWrapperInner = styled.div`
  width: 26.55%;
  height: inherit;
  display: flex;
  justify-content: space-between;
`

const PreviousAnswer = styled.div`
  width: 10%;
  height: inherit;
  background-color: #0fbc1c;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  color: #ffffff;
`

const MultiplierLabel = styled.div`
  //width: ${props => 4}vh;
  width: 2.5%;
  height: inherit;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  color: #ffffff;
`

const ResultTitleInput = styled.input`
  width: ${props => 37}vh;
  height: inherit;
  background-color: #ffffff;
  text-indent: ${props => 1}vh;
  border: none;
  outline: none;
  text-transform: uppercase;
  color: #000000;
  border-right: ${props => 0.1}vh solid #414042;
`

const ButtonGroup = styled.div`
  width: 15%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #eaeaea;
`

const StartPlayButton = styled.div`
  width: ${props => 25}vh;
  height: inherit;
  color: ${props => props.color || '#c61818'};
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  &:after {
    content: '${props => props.text}';
  }
  opacity: ${props => (props.isStarted ? 0.2 : 1)};
`

const PlayAnalyticsWrapper = styled.div`
  font-size: small;
  display: flex;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  background-color: #ffffff;
  max-width: 17%;
  min-width: 17%;
`

const ConfirmButton = styled.div`
  //width: ${props => 25}vh;
  width: 40%;
  height: inherit;
  color: #ffffff;
  background-color: #18c5ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.locked || props.resolving ? 'default' : 'pointer')};
  opacity: ${props => (props.locked ? 0.2 : 1)};
  &:before {
    content: 'RESOLVE';
    width: 100%;
    display: flex;
    justify-content: center;
  }
`

const EndPlayButton = styled.div`
  width: ${props => 25}vh;
  height: inherit;
  color: ${props =>
    props.isStarted && !props.isEnded ? '#ffffff' : '#cccccc'};
  background-color: ${props => props.backgroundColor || '#c61818'};
  display: flex;
  justify-content: center;
  align-items: center;
  &:after {
    content: '${props => props.text}';
  }
  position: relative;
  opacity: ${props => (props.isStarted && !props.isEnded ? 1 : 0.2)};
`

const Prompt = styled.span`
  visibility: hidden;
  width: auto;
  min-width: ${props => 16}vh;
  background-color: #17c5ff;
  text-align: center;
  border-radius: ${props => 0.5}vh;
  padding: ${props => 0.5}vh ${props => 0.5}vh;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  //left: 50%;
  right: 0;
  margin-left: ${props => -8}vh;
  opacity: 0;
  transition: opacity 0.3s;
  font-family: pamainregular;
  font-size: ${props => 2}vh;
  color: #000000;

  &:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: ${props => -0.8}vh;
    border-width: ${props => 0.8}vh;
    border-style: solid;
    border-color: #17c5ff transparent transparent transparent;
  }
`

const PendingIndicator = styled.div`
  width: auto;
  height: 100%;
  display: none;
  align-items: center;
  margin-right: 3%;
  &:after {
    content: '';
    display: block;
    width: ${props => h * 0.75}vh;
    height: ${props => h * 0.75}vh;
    background-image: url(${props => props.src});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    animation: ${props => pendingRotate} 5s linear infinite;
    transformorigin: center center;
  }
`
const AwardHeader = styled.span`
  color: ${props => props.color || '#ccc'};
  margin-right: 0px;
  font-size: 1.4vh;
`

const AwardValue = styled.span`
  color: #fff;
  font-size: medium;
`

const AwardsWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 8px;
  justify-content: space-between;
`
const VerticalDivider = styled.span`
  color: #ccc;
  margin: 0 4px;
`

const pendingRotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`

const Section = styled.div`
  width: 90%;
  height: 100%;
  display: flex;
  flex-direction: row;
`

const DDSponsorWrapper = styled.div`
  width: 60%;
  position: relative;
  display: none;
`

const AwardValuePercentage = styled.span`
  font-size: medium;
  color: #4a5adb;
  padding-left: 3px;
`



// WEBPACK FOOTER //
// src/Components/CommandHost/PlayItemUnresolved.js